var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFolderLg = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 36,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 2h14.774a2 2 0 0 1 1.533.715l4.167 4.97a2 2 0 0 0 1.532.715H44a2 2 0 0 1 2 2V32a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z",
  stroke: "#D1D3DA",
  strokeWidth: 3
})));
export { SvgFolderLg as ReactComponent };
export default __webpack_public_path__ + "6441a08fda8f34302a161c044992ce91.svg";